// Major Indian cities for dropdown
export const INDIAN_CITIES = [
  'Mumbai',
  'Delhi',
  'Bengaluru',
  'Hyderabad',
  'Ahmedabad',
  'Chennai',
  'Kolkata',
  'Pune',
  'Jaipur',
  'Surat',
  'Lucknow',
  'Kanpur',
  'Nagpur',
  'Indore',
  'Thane',
  'Bhopal',
  'Visakhapatnam',
  'Pimpri-Chinchwad',
  'Patna',
  'Vadodara',
  'Ghaziabad',
  'Ludhiana',
  'Agra',
  'Nashik',
  'Faridabad',
  'Meerut',
  'Rajkot',
  'Kalyan-Dombivali',
  'Vasai-Virar',
  'Varanasi',
  'Srinagar',
  'Aurangabad',
  'Dhanbad',
  'Amritsar',
  'Navi Mumbai',
  'Allahabad',
  'Ranchi',
  'Howrah',
  'Coimbatore',
  'Jabalpur',
  'Gwalior',
  'Vijayawada',
  'Jodhpur',
  'Madurai',
  'Raipur',
  'Kota',
  'Chandigarh',
  'Guwahati',
  'Solapur',
  'Hubli-Dharwad',
  'Mysore',
  'Tiruchirappalli',
  'Bareilly',
  'Aligarh',
  'Tiruppur',
  'Moradabad',
  'Jalandhar',
  'Bhubaneswar',
  'Salem',
  'Warangal',
  'Guntur',
  'Bhiwandi',
  'Saharanpur',
  'Gorakhpur',
  'Bikaner',
  'Amravati',
  'Noida',
  'Jamshedpur',
  'Bhilai',
  'Cuttack',
  'Firozabad',
  'Kochi',
  'Nellore',
  'Bhavnagar',
  'Dehradun',
  'Durgapur',
  'Asansol',
  'Rourkela',
  'Nanded',
  'Kolhapur',
  'Ajmer',
  'Akola',
  'Gulbarga',
  'Jamnagar',
  'Ujjain',
  'Loni',
  'Siliguri',
  'Jhansi',
  'Ulhasnagar',
  'Jammu',
  'Sangli-Miraj-Kupwad',
  'Mangalore',
  'Erode',
  'Belgaum',
  'Ambattur',
  'Tirunelveli',
  'Malegaon',
  'Gaya',
  'Jalgaon',
  'Udaipur',
  'Maheshtala',
  'Greater Noida',
  'Gurgaon',
  'Rewari',
  'Palwal',
  'Panvel',
  'Lonavala',
  'Tumkur',
  'Kolar',
  'Kanchipuram',
  'Tiruvallur',
  'Chengalpattu',
  'Unnao',
  'Mathura',
  'Prayagraj',
  'Alwar',
  'Bundi',
  'Baran',
  'Pali',
  'Gandhinagar',
  'Navsari',
  'Bharuch',
  'Salt Lake',
  'Secunderabad',
  'Dewas',
  'Vidisha',
  'Hajipur',
  'Muzaffarpur',
  'Puri',
  'Ernakulam',
  'Thrissur',
  'Kollam',
  'Thiruvananthapuram',
  'Trivandrum',
];

// Predefined nearby city relationships (~50-100km radius)
export const CITY_CLUSTERS = {
  // NCR Region
  'Delhi': ['Noida', 'Gurgaon', 'Faridabad', 'Ghaziabad', 'Greater Noida'],
  'Noida': ['Delhi', 'Ghaziabad', 'Greater Noida', 'Faridabad'],
  'Gurgaon': ['Delhi', 'Faridabad', 'Rewari'],
  'Ghaziabad': ['Delhi', 'Noida', 'Meerut'],
  'Faridabad': ['Delhi', 'Noida', 'Gurgaon', 'Palwal'],
  'Greater Noida': ['Noida', 'Delhi', 'Ghaziabad'],

  // Mumbai Metropolitan Region
  'Mumbai': ['Thane', 'Navi Mumbai', 'Kalyan-Dombivali', 'Vasai-Virar', 'Bhiwandi'],
  'Thane': ['Mumbai', 'Navi Mumbai', 'Kalyan-Dombivali'],
  'Navi Mumbai': ['Mumbai', 'Thane', 'Panvel'],

  // Pune Region
  'Pune': ['Pimpri-Chinchwad', 'Lonavala'],
  'Pimpri-Chinchwad': ['Pune'],

  // Karnataka
  'Bengaluru': ['Mysore', 'Tumkur', 'Kolar'],
  'Bangalore': ['Mysore', 'Tumkur', 'Kolar'],

  // Tamil Nadu
  'Chennai': ['Kanchipuram', 'Tiruvallur', 'Chengalpattu'],

  // Uttar Pradesh
  'Lucknow': ['Kanpur', 'Unnao'],
  'Kanpur': ['Lucknow', 'Unnao'],
  'Agra': ['Mathura', 'Firozabad'],
  'Varanasi': ['Allahabad', 'Prayagraj'],

  // Rajasthan
  'Jaipur': ['Ajmer', 'Alwar'],
  'Kota': ['Bundi', 'Baran'],
  'Jodhpur': ['Pali'],

  // Gujarat
  'Ahmedabad': ['Gandhinagar', 'Vadodara'],
  'Surat': ['Navsari', 'Bharuch'],

  // West Bengal
  'Kolkata': ['Howrah', 'Salt Lake', 'Durgapur'],

  // Telangana/Andhra
  'Hyderabad': ['Secunderabad', 'Warangal'],

  // Madhya Pradesh
  'Indore': ['Ujjain', 'Dewas'],
  'Bhopal': ['Vidisha'],

  // Bihar
  'Patna': ['Hajipur', 'Muzaffarpur'],

  // Odisha
  'Bhubaneswar': ['Cuttack', 'Puri'],

  // Kerala
  'Kochi': ['Ernakulam', 'Thrissur'],
  'Cochin': ['Ernakulam', 'Thrissur'],
  'Thiruvananthapuram': ['Kollam'],
  'Trivandrum': ['Kollam'],
};

// City name aliases for normalization
export const CITY_ALIASES = {
  // Common variations
  'New Delhi': 'Delhi',
  'NCT of Delhi': 'Delhi',
  'National Capital Territory of Delhi': 'Delhi',

  // Delhi districts (returned by geocoding)
  'Central Delhi': 'Delhi',
  'South Delhi': 'Delhi',
  'North Delhi': 'Delhi',
  'East Delhi': 'Delhi',
  'West Delhi': 'Delhi',
  'South West Delhi': 'Delhi',
  'South East Delhi': 'Delhi',
  'North West Delhi': 'Delhi',
  'North East Delhi': 'Delhi',
  'Shahdara': 'Delhi',

  // Renamed cities
  'Gurugram': 'Gurgaon',
  'Bengaluru': 'Bangalore',
  'Thiruvananthapuram': 'Trivandrum',
  'Kochi': 'Cochin',
  'Prayagraj': 'Allahabad',

  // Historical names (reverse mapping - we use modern names)
  'Bombay': 'Mumbai',
  'Madras': 'Chennai',
  'Calcutta': 'Kolkata',
  'Banaras': 'Varanasi',
  'Benares': 'Varanasi',
  'Poona': 'Pune',
  'Baroda': 'Vadodara',
  'Trivandrum': 'Thiruvananthapuram',
  'Cochin': 'Kochi',

  // District names that may be returned by geocoding
  'Gautam Buddha Nagar': 'Noida',
  'Gurugram District': 'Gurgaon',
  'Mumbai Suburban': 'Mumbai',
  'Mumbai City': 'Mumbai',
  'Bangalore Urban': 'Bangalore',
  'Bangalore Rural': 'Bangalore',
  'Chennai District': 'Chennai',
  'Hyderabad District': 'Hyderabad',
  'Pune District': 'Pune',
  'Lucknow District': 'Lucknow',
  'Jaipur District': 'Jaipur',
  'Ahmedabad District': 'Ahmedabad',
  'Kolkata District': 'Kolkata',
};

/**
 * Normalize city name to standard name
 * @param {string} city - City name to normalize
 * @returns {string|null} - Normalized city name
 */
export function normalizeCity(city) {
  if (!city) return null;

  const trimmedCity = city.trim();

  // Check if it's a known alias
  const aliasLower = trimmedCity.toLowerCase();
  for (const [alias, standard] of Object.entries(CITY_ALIASES)) {
    if (alias.toLowerCase() === aliasLower) {
      return standard;
    }
  }

  // Check if it's already a standard city name (case-insensitive match)
  for (const standardCity of Object.keys(CITY_CLUSTERS)) {
    if (standardCity.toLowerCase() === aliasLower) {
      return standardCity;
    }
  }

  // Fallback: Check if city name ends with a known standard city
  // This handles cases like "East Lucknow" -> "Lucknow", "North Mumbai" -> "Mumbai"
  for (const standardCity of Object.keys(CITY_CLUSTERS)) {
    if (aliasLower.endsWith(standardCity.toLowerCase())) {
      return standardCity;
    }
  }

  // Return as-is with proper capitalization
  return trimmedCity;
}

/**
 * Get nearby cities for a given city
 * @param {string} city - City name
 * @returns {string[]} - Array of nearby city names
 */
export function getNearbyCities(city) {
  if (!city) return [];
  const normalizedCity = normalizeCity(city);
  return CITY_CLUSTERS[normalizedCity] || [];
}

/**
 * Get city along with its nearby cities
 * @param {string} city - City name
 * @returns {string[]} - Array containing the city and its nearby cities
 */
export function getCityWithNearby(city) {
  if (!city) return [];
  const normalizedCity = normalizeCity(city);
  const nearby = getNearbyCities(normalizedCity);
  return [normalizedCity, ...nearby];
}

export const COURSE_OPTIONS = [
  // Civil Services & Defence
  'UPSC',
  'State PCS',
  'NDA',
  'CDS',
  // Medical
  'NEET',
  'AIIMS',
  // Engineering
  'JEE Main',
  'JEE Advanced',
  'GATE',
  // Management & Law
  'CAT',
  'CLAT',
  // Commerce & Professional
  'CA',
  'CS',
  // Government Jobs
  'SSC',
  'Banking',
  'IBPS',
  'RRB',
  'Railway',
  // Teaching & Academic
  'CTET',
  'UGC-NET',
  // University Entrance
  'CUET',
  // Other
  'Other',
];
